module.exports = __webpack_public_path__ + "img/menu-button-fill.7bbbbb28.svg";